import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-mattable',
	templateUrl:'./MatTablePage.html',
	styles: [],
	styleUrls:['./MatTablePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatTablePage
{
	mdContent_266 = `\`\`\`java
import com.jwebmp.plugins.angular.material.table.MatTable;
\`\`\``;
	mdContent_267 = `\`\`\`java
MatTable()
\`\`\``;
	mdContent_268 = `\`\`\`java
MatTable&lt;?&gt; table = new MatTable&lt;&gt;();
table.addColumn("name", "Name");
table.addColumn("email", "Email");
table.addColumn("role", "Role");
table.setDisplayedColumns(List.of("name", "email", "role"));
\`\`\``;
}
